import { render, staticRenderFns } from "./StepperImportDictionary.vue?vue&type=template&id=0fa90842&scoped=true"
import script from "./StepperImportDictionary.vue?vue&type=script&lang=js"
export * from "./StepperImportDictionary.vue?vue&type=script&lang=js"
import style0 from "./StepperImportDictionary.vue?vue&type=style&index=0&id=0fa90842&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa90842",
  null
  
)

export default component.exports